import { render, staticRenderFns } from "./Newsandtrends.vue?vue&type=template&id=9a69e702&"
import script from "./Newsandtrends.vue?vue&type=script&lang=js&"
export * from "./Newsandtrends.vue?vue&type=script&lang=js&"
import style0 from "./Newsandtrends.vue?vue&type=style&index=0&id=9a69e702&prod&lang=scss&"
import style1 from "./Newsandtrends.vue?vue&type=style&index=1&id=9a69e702&prod&lang=css&"
import style2 from "./Newsandtrends.vue?vue&type=style&index=2&id=9a69e702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports